export default function Input(theme) {
  return {
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            '& svg': { color: theme.palette.text.disabled },
          },
          fieldset: {
            legend: {
              width: 0,
            },
          },
        },
        input: {
          '&::placeholder': {
            opacity: 1,
            color: theme.palette.text_color.river_bed,
            fontSize: '14px',
            lineHeight: '24px',
            fontWeight: 500,
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          '&:before': {
            borderBottomColor: theme.palette.grey[500_56],
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.grey[500_12],
          '&:hover': {
            backgroundColor: theme.palette.grey[500_16],
          },
          '&.Mui-focused': {
            backgroundColor: theme.palette.action.focus,
          },
          '&.Mui-disabled': {
            backgroundColor: theme.palette.grey_dark[1000],
          },
        },
        underline: {
          '&:before': {
            borderBottomColor: theme.palette.grey[500_56],
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background_color.default,
          '&:hover': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.action.hover,
            },
          },
          '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.action.focus,
            },
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.grey_dark[1000],
          },
          '&.Mui-disabled': {
            color: 'white',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.grey_dark[1000],
              backgroundColor: theme.palette.background_color.disable_bg,
            },
          },
        },
        input: {
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: '24px',
          padding: '14px 20px',
          zIndex: 1,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          position: 'relative',
          transform: 'unset',
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: '24px',
          paddingLeft: '4px',
          marginBottom: '2px',
          color: `${theme.palette.text_color.cadet_grey} !important`,
        },
      },
    },
  };
}
